import React from 'react';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const JigsawHaikuLink = () => {
  return (
    <div className="previewTile">
      <div className="featureTitle">Jigsaw Haiku</div>
      <div className="announcement" style={{ textAlign: 'center' }}>
        Check out our other puzzle <a target="_blank" href="https://jigsawhaiku.com">Jigsaw Haiku<OpenInNewIcon className="externalLinkIcon"/></a>, which has its own site.
      </div>
    </div>
  );
};

export default JigsawHaikuLink;
